import { contactos } from '../config/contactos';

export const obtenerContacto = (apartado = 'general') => {
  const contacto = contactos[apartado] || {};
  return {
    whatsapp: contacto.whatsapp?.trim() || contactos.general.whatsapp,
    telefono: contacto.telefono?.trim() || contactos.general.telefono,
  };
};

const soloDigitos = (numero) => String(numero).replace(/\D/g, '');

export const crearWhatsAppUrl = (apartado = 'general', mensaje = '') => {
  const numero = soloDigitos(obtenerContacto(apartado).whatsapp);
  const texto = String(mensaje || '').trim();
  return `https://wa.me/${numero}${texto ? `?text=${encodeURIComponent(texto)}` : ''}`;
};

export const crearTelefonoUrl = (apartado = 'general') =>
  `tel:+${soloDigitos(obtenerContacto(apartado).telefono)}`;

export const formatearNumero = (numero) => {
  const digitos = soloDigitos(numero);
  return /^57\d{10}$/.test(digitos)
    ? `+57 ${digitos.slice(2, 5)} ${digitos.slice(5, 8)} ${digitos.slice(8)}`
    : `+${digitos}`;
};

export const contactoDeRuta = (pathname) => ({
  '/': 'inicio',
  '/page': 'inicio',
  '/internet': 'internet',
  '/television': 'television',
  '/canal': 'canal',
  '/envivo': 'envivo',
  '/catalogo': 'catalogo',
  '/historia': 'historia',
  '/pagos': 'pagos',
  '/normativa': 'normativa',
  '/politica-tratamiento-datos': 'politicaDatos',
  '/terminos-y-condiciones': 'pqrs',
}[pathname] || 'general');
